import { Component, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DashboardService } from '../../dashboard.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { DateTime } from 'luxon';
import { saveAs } from '@progress/kendo-file-saver';
import { Platform } from '@angular/cdk/platform';
import { EnvironmentService } from '../../../services/environment.service';
import { DateHandlingService } from '../../../services/date-handling.service';

@Component({
  selector: 'app-high-activity-stats',
  templateUrl: './highActivityStats.component.html',
  styleUrls: ['./highActivityStats.component.scss'],
  standalone: false,
})
export class HighActivityStatsComponent implements OnInit {
  private dateSvc = inject(DateHandlingService);
  private dbs = inject(DashboardService);
  private ss = inject(SessionStorageService);
  private router = inject(Router);
  private pltfrm = inject(Platform);
  private envSvc = inject(EnvironmentService);

  private environment;
  private baseUrl: string;

  loading = false;
  unitsManaged = this.ss.get('globals')?.user.managerUnits;
  unit =
    this.unitsManaged && this.unitsManaged.length > 0
      ? this.unitsManaged[0].id
      : null;
  app = this.ss.get('currentApp');
  startDate = new FormControl(
    DateTime.now().minus({ days: 30 }).startOf('day').toUTC().toISO()
  );
  endDate = new FormControl(DateTime.now().endOf('day').toUTC().toISO());
  data;
  viewingUser = false;
  limit30 = true;

  ngOnInit() {
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;

    const rights = this.ss.get('rights');
    this.limit30 = rights?.includes('limit30Days');

    this.getData();
  }

  getData(user?) {
    this.loading = true;
    this.viewingUser = user ? true : false;

    const start = this.limit30
      ? this.dateSvc.thirtyDays().start
      : this.dateSvc.toUseableString(this.startDate.value, 'start');

    const end = this.limit30
      ? this.dateSvc.thirtyDays().end
      : this.dateSvc.toUseableString(this.endDate.value, 'end');

    this.dbs
      .getUnitProfileCaseStats(this.unit, start, end, user)
      .subscribe(x => {
        this.data = x;
        this.loading = false;
      });
  }

  goToProfile(ev, id) {
    this.router.navigate([`/li/questionnaire/${id}`]);
  }

  exportCSV(user?) {
    this.loading = true;
    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);

    const start = this.limit30
      ? this.dateSvc.thirtyDays().start
      : this.dateSvc.toUseableString(this.startDate.value, 'start');

    const end = this.limit30
      ? this.dateSvc.thirtyDays().end
      : this.dateSvc.toUseableString(this.endDate.value, 'end');

    this.dbs
      .getProfileCaseStatsHistory(this.unit, start, end, user)
      .subscribe(x => {
        let fileData;
        const reader = new FileReader();
        reader.readAsDataURL(x);
        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, 'Activity-Results.csv', {
            proxyURL: `${this.baseUrl}/util/proxy`,
            proxyTarget: '_self',
            forceProxy: iosSafari,
          });
          this.loading = false;
        };
        this.loading = false;
      });
  }
}
